var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "the-header" },
    [
      _c(
        "b-navbar",
        { staticClass: "header", attrs: { fixed: "top" } },
        [
          _c(
            "b-navbar-brand",
            { staticClass: "ml-auto", attrs: { href: "#" } },
            [
              _c("span", { staticClass: "d-inline-block align-middle icon" }, [
                _c("img", {
                  attrs: {
                    src: require("../../assets/user.png"),
                    alt: "user image",
                  },
                }),
              ]),
              _vm._v(
                " " +
                  _vm._s(_vm.user.perfil.firstName) +
                  " " +
                  _vm._s(_vm.user.perfil.lastName) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }